import { render, staticRenderFns } from "./AccountsOfInterestEditor.vue?vue&type=template&id=789a018a"
import script from "./AccountsOfInterestEditor.vue?vue&type=script&lang=ts"
export * from "./AccountsOfInterestEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports